<template>
  <p class="mt-2 text-xs custom-hint" v-if="hint">{{hint}}</p>
</template>
<script>
export default {
  props:{
    hint: String
  }
}
</script>
<style scoped>
.custom-hint{
  color: #adadad;
}
</style>
